/**
 * This list documents valid RPC function names in Supabase
 * Add all valid function names here for documentation purposes
 */
export const VALID_RPC_FUNCTIONS = [
  "get_waitlist_entries_with_details",
  "current_family_id",
  "current_org_id",
  "current_role",
  "debug_staff_insert",
  "get_user_org_id",
  "get_user_organization_id",
  "is_bizadmin",
  "is_bizadmin_or_owner", 
  "insert_notification_target",
  "user_is_parent_in_family",
  "is_staff",
  "is_site_admin",
  "request_makeup_class",
  "sign_policy"
] as const; 